import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";

import { SvgIconComponent } from "@hermes/aphrodite/svg";
import { GridFacade } from "@hermes/states/grid-filters-state";
import { TrayStateModule } from "@hermes/states/tray";
import { GridFiltersTrayModule } from "@hermes/trays/grid-filters";
import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic/directives/sr-only-no-snippet";

@Component({
    imports: [
        CommonModule,
        SvgIconComponent,
        TrayStateModule,
        GridFiltersTrayModule,
        SrOnlyNoSnippetDirective,
    ],
    selector: "h-grid-filter-section",
    standalone: true,
    styleUrl: "./grid-filter-section.component.scss",
    templateUrl: "./grid-filter-section.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridFilterSectionComponent {
    public nbFiltersSelected$ = this.gridFacade.nbFiltersSelected$;

    constructor(private gridFacade: GridFacade) {}
}
